import { Box, Typography } from "@mui/material";
import * as React from "react";
import { Dialog } from "source/components/framework/Dialog/Dialog";
import { TreeCheckBoxDropdownItems } from "ui/Scripts/source/components/framework/Dropdown/TreeCheckboxDropdown/TreeCheckboxDropdownItems";
import { IIdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";
import { Translations } from "ui/Scripts/source/models/translations";

export interface ISelectQualificationDialogProps {
    nodes: IIdTitleNode[];
    selectedIds: string[];
    onOk: (selectedIds: string[]) => void;
    onCancel: () => void;
}

export interface ISelectQualificationDialogState {
    selectedIds: string[];
    eductionGroupNodes: IIdTitleNode[];
    eductionNodes: IIdTitleNode[];
}

export class SelectQualificationDialog extends React.Component<ISelectQualificationDialogProps, ISelectQualificationDialogState> {
    constructor(props: ISelectQualificationDialogProps) {
        super(props);
        this.state = {
            selectedIds: props.selectedIds ?? [],
            eductionGroupNodes: props.nodes?.filter(i => i.active) ?? [],
            eductionNodes: props.nodes?.filter(i => !i.active && !!i.getFirstActiveNode()) ?? []
        };
    }

    handleOk = () => {
        const props = this.props;
        const state = this.state;
        if (state.selectedIds.length < 1) return;
        props.onOk(state.selectedIds);
    };

    render() {
        const props = this.props;
        const state = this.state;
        return (
            <Dialog
                id="selectQualificationDialog"
                maxWidth="sm"
                title={Translations.SelectFurtherEducation + " / " + Translations.Competency}
                body={
                    <>
                        {state.eductionGroupNodes.length > 0 &&
                            <>
                                <Box>
                                    <Typography variant="subtitle1" fontWeight={600} m={"0 0 " + (state.eductionNodes.length > 0 ? ".5rem" : "0")} color="">
                                        {Translations.Groups}
                                    </Typography>
                                </Box>
                                <Box sx={{ margin: "0 -1rem 0 -0.5" }}>
                                    <TreeCheckBoxDropdownItems
                                        selectedIds={state.selectedIds}
                                        singleSelect={true}
                                        toggleAllId={""}
                                        values={state.eductionGroupNodes}
                                        onChange={selectedIds => this.setState({ selectedIds })}
                                    />
                                </Box>
                            </>
                        }
                        {state.eductionNodes.length > 0 &&
                            <>
                                <Box>
                                    <Typography variant="subtitle1" fontWeight={600} m={(state.eductionGroupNodes.length > 0 ? "1rem" : "0") + " 0 .5rem"} color="">
                                        {Translations.EducationsAndCompetencies}
                                    </Typography>
                                </Box>
                                <Box sx={{ margin: "0 -1rem 0 -0.5" }}>
                                    <TreeCheckBoxDropdownItems
                                        selectedIds={state.selectedIds}
                                        singleSelect={true}
                                        toggleAllId={""}
                                        values={state.eductionNodes}
                                        onChange={selectedIds => this.setState({ selectedIds })}
                                    />
                                </Box>
                            </>
                        }
                    </>
                }
                buttons={[
                    { title: Translations.Cancel, variant: "outlined", onClick: props.onCancel },
                    { title: Translations.OK, variant: "confirmation", onClick: this.handleOk, disabled: state.selectedIds.length < 1 },
                ]}
                onClose={props.onCancel}
            />
        );
    }
}